import {
  enumElementDrawStates,
  enumScrollBarType,
  kScrollBarButtonSize,
  kTriangleOffset
} from "../constants";
import { QElement } from "./QElement";

export class QScrollBarSlug extends QElement {
  constructor() {
    super();
    this.fCurrentPosition = 0;

    this.fSize = null;
    this.fSlugOffset = null;

    this.fLeftBarrierVal = -1;
    this.fRightBarrierVal = -1;
    this.fTopBarrierVal = -1;
    this.fBottomBarrierVal = -1;

    this.fSlugType = null;

    this.fSlugSize = null;
    this.fParentScrollBar = null;

    this.fCustomDrag = true;
  }

  InitSlug(parentScrollBar, scrollBarType) {
    this.SetHeight(kScrollBarButtonSize);
    this.SetWidth(kScrollBarButtonSize);
    this.fSlugType = scrollBarType;
    this.fParentScrollBar = parentScrollBar;
    this.SetFillColor("#999999");
    this.UpdateSlug();
    parentScrollBar.fParentPanel.PushElement(this);
    parentScrollBar.fSlug = this;

    this.SetDraggable(true);
  }

  SetPosition(position) {
    this.fCurrentPosition = position;
  }

  // Position within the element
  GetPosition() {
    return this.fCurrentPosition;
  }

  // Relative to 0
  GetValue() {
    return this.fCurrentPosition - kTriangleOffset;
  }

  SetLeftBarrier(x) {
    this.fLeftBarrierVal = x;
  }

  GetLeftBarrier() {
    return this.fLeftBarrierVal;
  }

  SetRightBarrier(x) {
    this.fRightBarrierVal = x;
  }

  GetRightBarrier() {
    return this.fRightBarrierVal;
  }

  SetTopBarrier(y) {
    this.fTopBarrierVal = y;
  }

  GetTopBarrier() {
    return this.fTopBarrierVal;
  }

  SetBottomBarrier(y) {
    this.fBottomBarrierVal = y;
  }

  GetBottomBarrier() {
    return this.fBottomBarrierVal;
  }

  RenderScrollBarSlug(drawBuffer) {
    var ctx = drawBuffer.getContext("2d");
    drawBuffer.getContext("2d");
    var thickness = 4;
    ctx.save();
    ctx.fillStyle = this.GetFillColor();

    var drawState = this.GetDrawState();
    switch (drawState) {
      case enumElementDrawStates.Hover:
        ctx.globalAlpha = 0.5;
        break;
      case enumElementDrawStates.MouseDown:
        ctx.globalAlpha = 1;
        break;
      case enumElementDrawStates.Disabled:
        break;
      default:
        ctx.globalAlpha = 0.25;
    }
    if (this.fSlugType === enumScrollBarType.horizontal)
      ctx.fillRect(
        this.fHorzOffset,
        this.fVertOffset + thickness,
        this.fWidth,
        this.fHeight - 2 * thickness
      );
    else
      ctx.fillRect(
        this.fHorzOffset + thickness,
        this.fVertOffset,
        this.fWidth - 2 * thickness,
        this.fHeight
      );
    ctx.restore();
  }

  DoRenderElement(drawBuffer) {
    //this.RenderScrollBarSlug(drawBuffer);
  }

  UpdateSlug() {
    var parentScrollBar = this.fParentScrollBar;
    var targetPanel = parentScrollBar.GetScrollBarTargetPanel();
    var width = targetPanel.GetWidth();
    var height = targetPanel.GetHeight();
    var scaleFactor = parentScrollBar.GetScrollBarTargetPanel().fScaleFactor;
    if (scaleFactor == null) scaleFactor = 1;
    var scaledWidth = width * scaleFactor;
    var scaledHeight = height * scaleFactor;
    var position = 0;
    if (this.fSlugType === enumScrollBarType.horizontal) {
      this.fSlugSize = (parentScrollBar.fTrackSize * targetPanel.fPortWidth) / scaledWidth;
      this.SetWidth(this.fSlugSize);
      if (parentScrollBar.fHasButtons) {
        this.SetLeftBarrier(parentScrollBar.GetPositionX() + kScrollBarButtonSize);
        this.SetRightBarrier(
          parentScrollBar.GetPositionX() + parentScrollBar.fTrackSize + kScrollBarButtonSize
        );
      } else {
        this.SetLeftBarrier(parentScrollBar.GetPositionX());
        this.SetRightBarrier(parentScrollBar.GetPositionX() + parentScrollBar.fTrackSize);
      }
      position =
        ((targetPanel.fPanX * scaleFactor) / (scaledWidth - targetPanel.fPortWidth)) *
        (parentScrollBar.fTrackSize - this.GetWidth());
      if (parentScrollBar.fHasButtons) position += kScrollBarButtonSize;
      this.fCurrentPosition = position;
      this.SetPositionX(position + this.fParentScrollBar.GetPositionX());
      this.SetPositionY(parentScrollBar.GetPositionY());
    } else {
      this.fSlugSize = (parentScrollBar.fTrackSize * targetPanel.fPortHeight) / scaledHeight;
      this.SetHeight(this.fSlugSize);
      if (parentScrollBar.fHasButtons) {
        this.SetTopBarrier(parentScrollBar.GetPositionY() + kScrollBarButtonSize);
        this.SetBottomBarrier(
          parentScrollBar.GetPositionY() + parentScrollBar.fTrackSize + kScrollBarButtonSize
        );
      } else {
        this.SetTopBarrier(parentScrollBar.GetPositionY());
        this.SetBottomBarrier(parentScrollBar.GetPositionY() + parentScrollBar.fTrackSize);
      }
      position =
        ((targetPanel.fPanY * scaleFactor) / (scaledHeight - targetPanel.fPortHeight)) *
        (parentScrollBar.fTrackSize - this.GetHeight());
      if (parentScrollBar.fHasButtons) position += kScrollBarButtonSize;
      this.fCurrentPosition = position;
      this.SetPositionY(position + this.fParentScrollBar.GetPositionY());
      this.SetPositionX(parentScrollBar.GetPositionX());
    }
  }

  MoveElement(deltaX, deltaY) {
    //console.log("hold");
    var parentScrollBar = this.fParentScrollBar;
    var targetPanel = parentScrollBar.GetScrollBarTargetPanel();
    var backgroundPanel = parentScrollBar.GetScrollBarBackgroundPanel();
    var xPanel = this.GetPositionX();
    var yPanel = this.GetPositionY();
    var newX = xPanel;
    var newY = yPanel;
    if (this.fSlugType === enumScrollBarType.horizontal) {
      newX += deltaX;
      var leftBarrier = this.GetLeftBarrier();
      var rightBarrier = this.GetRightBarrier();
      var width = this.GetWidth();
      if (newX <= leftBarrier) {
        newX = leftBarrier;
      } else if (newX >= rightBarrier - width) {
        newX = rightBarrier - width;
      }
      var newPanX = ((newX - leftBarrier) / parentScrollBar.fTrackSize) * targetPanel.GetWidth();
      newPanX = Math.round(newPanX);
      targetPanel.SetPanX(newPanX);
    } else {
      newY += deltaY;
      var topBarrier = this.GetTopBarrier();
      var bottomBarrier = this.GetBottomBarrier();
      var height = this.GetHeight();
      if (newY <= topBarrier) {
        newY = topBarrier;
      } else if (newY >= bottomBarrier - height) {
        newY = bottomBarrier - height;
      }
      var newPanY = ((newY - topBarrier) / parentScrollBar.fTrackSize) * targetPanel.GetHeight();
      newPanY = Math.round(newPanY);
      targetPanel.SetPanY(newPanY);
    }
    backgroundPanel.PanExtras();
    backgroundPanel.PanYAssociates(targetPanel, newPanY);
  }
}
